// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3Hhum","notes":"Notes_notes__2yXAK"};